<template>
  <div class="discover-page">
    <div class="discover-banner">
      <header class="discover-header">
        <div class="discover-header__inner">
          <h1 class="discover-title">Descobrir</h1>
          <p class="discover-lead">
            Encontre novas histórias, acompanhe lançamentos e volte para as suas obras salvas.
          </p>
        </div>
      </header>

      <div class="discover-container">
        <v-tabs :value="activeTab" class="discover-tabs">
          <v-tab
            v-for="tab in tabs"
            :key="tab.to"
            :tab-value="tab.to"
            @click="goTo(tab.to)"
          >
            {{ tab.label }}
          </v-tab>
        </v-tabs>
      </div>
    </div>

    <main class="discover-content">
      <router-view />
    </main>
  </div>
</template>

<script>
import "@/styles/discover-page.css";

const TABS = [
  { label: "Agendados", to: "/descobrir/agendados" },
  { label: "Categorias", to: "/descobrir/categorias" },
  { label: "Biblioteca", to: "/descobrir/biblioteca" },
];

export default {
  name: "DiscoverView",
  data() {
    return {
      tabs: TABS,
    };
  },
  computed: {
    activeTab() {
      const current = this.$route.path;
      const match = this.tabs.find((tab) => current === tab.to);
      return match ? match.to : this.tabs[0].to;
    },
  },
  created() {
    if (this.$route.path === "/descobrir" || this.$route.path === "/descobrir/") {
      this.$router.replace({ path: this.tabs[0].to });
    }
  },
  methods: {
    goTo(path) {
      if (this.$route.path !== path) {
        this.$router.push(path);
      }
    },
  },
};
</script>
